import React from "react";
import {
  XYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  HorizontalGridLines,
  LineSeries,
} from "react-vis";

import "../../../node_modules/react-vis/dist/style.css";
export default function DashGraph({
  xDomain = [-1, 3],
  yDomain = [-5, 15],
  xAxisOn0 = true,
  yAxisOn0 = true,
  verticalTickValues = [],
  horizontalTickValues = [0],
}) {
  return (
    <XYPlot width={130} height={100} stroke="#04d09a" {...{ xDomain, yDomain }}>
      {!verticalTickValues || verticalTickValues.length ? (
        <VerticalGridLines tickValues={verticalTickValues} />
      ) : null}
      {!horizontalTickValues || horizontalTickValues.length ? (
        <HorizontalGridLines tickValues={horizontalTickValues} />
      ) : null}

      <LineSeries
        data={[
          { x: 0, y: 0 },
          { x: 1, y: 10 },
          { x: 2, y: 2 },
          { x: 3, y: 7 },
          { x: 4, y: 9 },
          { x: 5, y: 19 },
          { x: 6, y: 14 },
          { x: 7, y: 8 },
          { x: 8, y: 10 },
          { x: 9, y: 18 },
        ]}
      />
    </XYPlot>
  );
}
